import { useState,useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useParams, useHistory } from "react-router-dom";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import customMarker from "../assets/markerNiku.png";
import { GetBusinessInfo, GetGeoLocationShop } from "../Business/Infrastructure/Business.presenter";
import MyMap from "./Map";

const mapStyles = {
  width: "100%",
  height: "470px",
}

const useStyles = makeStyles(()=>({
  principalContainer:{
    minHeight: "100vh",
    height: "auto",
    width: "100%",
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    paddingBottom: 70,
  },
  marker:{
    width: 41,
    height: 42,
  },
  infoContainer:{
    width: "100%",
    padding: "10px 25px",
    maxHeight: 190,
  },
  businesssName:{
    fontSize: "1.875rem",
    lineHeight: "36.57px",
    color: "#333333",
    fontWeight: 500
  },
  addressContainer:{
    marginTop: 20,
    width: "90%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 15
  },
  address:{
    fontSize: "0.8125rem",
    lineHeight: "15.25px",
    color: "#4F4F4F",
    fontWeight: 400
  }
}));

export default function MobileMap(){
  const {id} = useParams();
  const history = useHistory();
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState({});
  const [coords, setCoords] = useState({lat: 0, lng: 0});
  
  const handleResizeWindow = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 768) {
      history.push(`/negocio/${id}`)
    }
  };

  useEffect(() => {
    if (id) {
      //setLoading(true);
      getLocation(id);
      getAddress();
      window.addEventListener("resize", handleResizeWindow);
      window.addEventListener("load", handleResizeWindow);
    }
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
      window.addEventListener("load", handleResizeWindow);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getAddress = async () => {
    try {
      const {info} = await GetBusinessInfo(id);
      setInfo(info);
     } catch (error) {
       console.log("ocurrio un error", error)
     }
  }

  async function getLocation(id){
    try {
      const {lat, lng} = await GetGeoLocationShop(id);
      setCoords({lat, lng})
      setLoading(false);
    } catch (error) {
      console.log("Error al obtener coordenadas :(", error);
    }
  }

  return !loading && (
    <div className={classes.principalContainer}>
      <ChevronLeftOutlinedIcon sx={{display: { zIndex: 200,md: "none", color: "#004990", position: "absolute", top: "20px", left: "15px"}}} onClick={() => history.push(`/negocio/${id}`)}/>
      <div style={{width: "100%", height: "470px"}}>
        <MyMap lat={coords.lat} lng={coords.lng} customStyles={mapStyles} isDraggable={false} mapTypeControl={false}/>
      </div>
      <div className={classes.infoContainer}>
        <h4 className={classes.businesssName}>{info.shop_name}</h4>
        <div className={classes.addressContainer}>
          <img className={classes.marker} src={customMarker} alt="niku marker"/>
          <p className={classes.address}>{info.address_shop}</p>
        </div>
      </div>
    </div>
  );
}